import { render, staticRenderFns } from "./observacaoDetalhar.vue?vue&type=template&id=ee6247ec"
import script from "./observacaoDetalhar.vue?vue&type=script&lang=js"
export * from "./observacaoDetalhar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports